import { render, staticRenderFns } from "./OrderConfirmedCard.vue?vue&type=template&id=45fd6ac0&"
import script from "./OrderConfirmedCard.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QCardActions})
